import React, { Fragment, useEffect, useState, useRef } from 'react'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import { openSpecificImage } from 'components/ImageViewer/ImageViewerActions'
import { setErrorToast } from '../../actions'
import { checkDLNValid } from 'components/BOSearch/BOSearchActions'
import CaretDownIcon from '@tecuity/sos-icons/react/caret-down'
import CaretUpIcon from '@tecuity/sos-icons/react/caret-up'
import DownloadIcon from '@tecuity/sos-icons/react/download-box'
import { GET_RECORD_HISTORY, GET, VOID_FILING } from 'requests'
import { BASE_URL } from 'requests'
import './RecordHistory.scss'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useHistory } from 'react-router'
import { useRequestData } from '../../Utilities/hooks'
// import { DownloadChip } from '@tecuity/granite-ui/DownloadChip'
// import { format } from 'date-fns'
import { Report } from '../MyWorkQueue/ReportsList'
import { Spinner } from '../Loaders/Loaders'
import { ContextButton } from '@tecuity/granite-ui'
import VoidModal from '../VoidModal/VoidModal'
import { format } from 'date-fns'
import FileDownloader from '../ImageViewer/FileDownloader'
import EditFilingModal from '../RecordDetailsPage/BusinessEntity/EditFilingModal'
import Markdown from '../Markdown/Markdown'
import store from '../../store'

const isIE11 = !!window.MSInputMethodContext && !!document.documentMode

export class ConnectedRecordHistory extends React.Component {
  state = {
    modalOpen: false,
    history: null,
    loading: false,
  }
  startModalOpen = () => {
    if (this.props.category && this.props.amendmentNum) {
      this.fetchHistory()
    }
  }
  fetchHistory = () => {
    this.setState({ loading: true })
    GET_RECORD_HISTORY(
      this.props.category,
      this.props.amendmentNum,
      (history) => {
        this.setState({
          loading: false,
          history: {
            amendments: history.AMENDMENT_LIST.map((amd, i) => ({ ...amd, index: i })),
            history: history.HISTORY_LIST || [],
            template: history.TEMPLATE,
          },
          modalOpen: true,
        })
      },
      (err) => {
        console.error(err)
        this.setState({ loading: false })
      },
    )
  }
  openModal = () => {
    this.setState({
      modalOpen: true,
    })
  }
  closeModal = () => {
    this.setState({
      modalOpen: false,
    })
  }
  forceWindowRepaint = () => {
    if (isIE11) {
      this.scrollable.style.overflow = 'hidden'
      window.setTimeout(() => {
        this.scrollable.style.overflow = 'auto'
      }, 100)
    }
  }
  render() {
    const { children, ...restProps } = this.props
    return (
      <Fragment>
        {children({ openModal: this.startModalOpen, loading: this.state.loading })}
        <Portal isOpened={this.state.modalOpen}>
          <Modal
            modalSize="fullscreen"
            closeModal={this.closeModal}
            title="History"
            closeButton
            modalBodyClassName="history-modal"
          >
            <div
              className="scrollable"
              ref={(ref) => {
                this.scrollable = ref
              }}
            >
              <RecordHistory
                history={this.state.history}
                onDrawerUpdate={this.forceWindowRepaint}
                {...restProps}
              />
            </div>
          </Modal>
        </Portal>
      </Fragment>
    )
  }
}

export default class RecordHistory extends React.Component {
  constructor(props) {
    super(props)
    const h = props.history
    const amendments = this.memoizeHistoryStructure(h)
    let zeroFilingsMessage = store.getState().app.appSettings['RecordHistoryZeroFilingsMessage']
    this.state = {
      amendments,
      allExpanded: h.history && h.history.length < 5 && h.amendments && h.amendments.length <= 4,
      reset: false,
      zeroFilingsMessage,
    }
  }
  componentDidUpdate = (prevProps) => {
    if (this.props.history !== prevProps.history) {
      const h = this.props.history
      const amendments = this.memoizeHistoryStructure(h)
      this.setState({
        amendments,
        allExpanded: h.history && h.history.length < 5 && h.amendments && h.amendments.length <= 4,
      })
    }
  }
  memoizeHistoryStructure = ({ amendments, history }) => {
    return (amendments || []).map((amd) => ({
      ...amd,
      // Only memoize this for the old way. The new way just nests the details inside the amendments they belong to.
      HISTORY:
        amd.HistoryDetails ||
        (history || []).filter(
          (h) =>
            (h.CHANGED_FROM || h.CHANGED_TO) &&
            (h.AMENDMENT_ID === amd.AMENDMENT_ID || (h.Id && h.Id === amd.Id)),
        ),
    }))
  }
  toggleDrawers = () => {
    this.setState(
      (state) => ({ allExpanded: !state.allExpanded }),
      () => {
        if (isIE11) {
          this.props.onDrawerUpdate()
        }
      },
    )
  }
  render() {
    const { amendments } = this.state
    const {
      history: { template },
      userOwnsRecord,
      requiredVoidRight = '',
      requiredEditRight = '',
      setHistory,
      module,
      showChangedFromTo,
    } = this.props
    return (
      <div
        className="record-history"
        style={this.state.reset ? { transform: 'translateY(1px)' } : undefined}
      >
        <div className="toolbar">
          <div className="num-filings" role="status">
            Total filings: {amendments.length}
          </div>
          <button role="button" className="btn btn-raised btn-primary" onClick={this.toggleDrawers}>
            {this.state.allExpanded ? 'Collapse All' : 'Expand All'}
          </button>
        </div>
        {(amendments || []).map((amd, i) => (
          <CollapsibleAmendment
            amendments={amendments}
            amendment={amd}
            template={template}
            allExpanded={this.state.allExpanded}
            userOwnsRecord={userOwnsRecord}
            onDrawerUpdate={this.props.onDrawerUpdate}
            key={amd.AMENDMENT_ID || amd.Id}
            EditComponent={this.props.EditComponent}
            requiredVoidRight={requiredVoidRight}
            requiredEditRight={requiredEditRight}
            setHistory={setHistory}
            module={module}
            showChangedFromTo={showChangedFromTo}
          />
        ))}
        {(!amendments || amendments.length === 0) && !!this.state.zeroFilingsMessage && (
          <Markdown className="markdown" source={this.state.zeroFilingsMessage} />
        )}
      </div>
    )
  }
}

export const CollapsibleAmendment = ({
  amendments,
  amendment,
  template,
  onDrawerUpdate,
  allExpanded,
  // EditComponent,
  requiredVoidRight,
  requiredEditRight,
  setHistory = () => {},
  module = '',
  showChangedFromTo = true,
}) => {
  const [voidModalOpen, setVoidModalOpen] = useState(false)
  const [editModalOpen, setEditModalOpen] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const [expanded, setExpanded] = React.useState(false)
  const { appUserRights } = useSelector((state) => state.auth, shallowEqual)
  const duplicateAmendments = amendments.filter(
    (amd) =>
      amd.AMENDMENT_DATE === amendment.AMENDMENT_DATE &&
      amendment.AMENDMENT_DATE &&
      amd.AMENDMENT_TYPE === amendment.AMENDMENT_TYPE &&
      amd.FilingType === amendment.FilingType &&
      amd.AMENDMENT_ID !== amendment.AMENDMENT_ID,
  )
  const duplicateCounter =
    1 + duplicateAmendments.filter((amd) => amd.index < amendment.index).length
  const [noDownloadMessage, setNoDownloadMessage] = useState()

  useEffect(() => {
    let noDownloadMessage = store.getState().app.appSettings['RecordHistoryNoDownloadMessage']
    setNoDownloadMessage(noDownloadMessage)
  }, [])

  const toggleDrawer = () => {
    setExpanded((value) => !value)
  }

  useEffect(() => {
    if (isIE11) {
      onDrawerUpdate()
    }
  }, [expanded])

  useEffect(() => {
    setExpanded(allExpanded)
  }, [allExpanded])

  const getDLNLink = (dln) => {
    if (dln) {
      return (
        <div
          className={dln.indexOf(',') === -1 ? 'dlnTableLink' : ''}
          tabIndex={dln.indexOf(',') === -1 ? 0 : -1}
          onClick={() => {
            return dln.indexOf(',') === -1
              ? checkDLNValid(
                  dln,
                  (id) => {
                    dispatch(openSpecificImage(id, dln))
                  },
                  (dln) => {
                    dispatch(setErrorToast('DLN ' + dln + ' not found'))
                  },
                )
              : null
          }}
        >
          {dln}
        </div>
      )
    } else {
      return ''
    }
  }

  const getReceiptLink = (ReceiptNum) => {
    if (ReceiptNum === 'Multiple' || ReceiptNum === 'N/A') return ReceiptNum
    const receiptNum = ReceiptNum.split(' ')[0]
    const receiptAmountText =
      ReceiptNum.split(' ').length > 1 ? ReceiptNum.substring(ReceiptNum.indexOf(' ') + 1) : ''
    return receiptNum.trim() ? (
      <div className="receipt-num-holder" key={receiptNum}>
        {appUserRights.includes('ReceiptView') ? (
          <div
            className="dlnTableLink"
            tabIndex={0}
            onClick={() => {
              history.push(`/accounting/receipt/${receiptNum}`)
            }}
          >
            {receiptAmountText ? '(' : ''}
            {receiptNum}
            {receiptAmountText ? ')' : ''}
          </div>
        ) : (
          <div>
            {receiptAmountText ? '(' : ''}
            {receiptNum}
            {receiptAmountText ? ')' : ''}
          </div>
        )}
        {receiptAmountText && <div>&nbsp;{receiptAmountText}</div>}
      </div>
    ) : null
  }

  const formatMoneyAmount = (value) => {
    return Number(value)
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  const getDetailByType = (t, value, amendment) => {
    // Combine the old structure names with new structure names
    const ct = {
      Type: t.type || t.Type,
      Label: t.label || t.Label,
      Id: t.id || t.Id,
      IsEnabled: t.enabled || t.IsEnabled,
      IsEditable: t.isEditable || t.IsEditable,
      EditType: t.editType || t.EditType,
      ApiCall: t.apiCall || t.ApiCall,
    }
    switch ((ct.Type || '').toLowerCase()) {
      case 'amount':
        return <Detail label={ct.Label} value={`$${formatMoneyAmount(value)}`} key={ct.Id} />
      case 'customlabel':
        return <Detail label={amendment[t.labelKey] || ct.Label} value={value} key={ct.Id} />
      case 'correspondence':
        return (
          <CorrespondenceDownload key={ct.Id} template={ct} value={value} amendment={amendment} />
        )
      case 'dln':
        return (
          <Detail label={ct.Label} key={ct.Id}>
            {getDLNLink(value) || 'Not in System'}
          </Detail>
        )
      case 'download':
        return value ? (
          <Detail label={ct.Label} key={ct.Id}>
            {/* <a download={`${t.Label}.pdf`} target="blank" href={`${BASE_URL}${value}`}>
              <DownloadIcon />
              {t.linkLabel || 'Download'}
            </a> */}
            <DownloaderWrapper
              href={`${BASE_URL}${value}`}
              filename={`${ct.Label}.pdf`}
              linkLabel={t.linkLabel}
            />
          </Detail>
        ) : noDownloadMessage && !amendment.HIDE_NO_DOWNLOAD_MESSAGE ? (
          <Detail label={ct.Label} key={ct.Id}>
            <Markdown className="markdown" source={noDownloadMessage} />
          </Detail>
        ) : null
      case 'hideifnull':
        return value ? <Detail label={ct.Label} value={value} key={ct.Id} /> : null
      case 'receiptnum':
        return (
          <Detail label={ct.Label} key={ct.Id}>
            {(value.split(';') || []).map((receipt, i) => {
              return i + 1 < value.split(';').length || value.split(';').length === 1
                ? getReceiptLink(receipt) || 'Not in System'
                : ''
            })}
          </Detail>
        )
      case 'voidbutton':
        if (!appUserRights.includes(requiredVoidRight)) return null
        const voidInfo = amendment.VOID_INFO || amendment.voidInfo || {}
        return (
          <div key={ct.Id} style={{ marginTop: '10px' }}>
            {amendment.STATUS !== 'Voided' && amendment.Status !== 'Voided' ? (
              <div>
                <ContextButton id={ct.Id} onClick={() => setVoidModalOpen(true)} variant="danger">
                  VOID
                </ContextButton>
                <VoidModal
                  voidModalOpen={voidModalOpen}
                  setVoidModalOpen={setVoidModalOpen}
                  label={amendment.CATEGORY}
                  category={amendment.CATEGORY}
                  voidMethod={(info) =>
                    VOID_FILING(
                      amendment.AMENDMENT_NUM || amendment.FilingNumber,
                      amendment.CATEGORY,
                      info,
                      () => {
                        window.location.reload()
                      },
                      (error) => {
                        dispatch(setErrorToast('Failed to void filing.'))
                      },
                    )
                  }
                />
              </div>
            ) : (
              <div>
                <Detail
                  label="Void Date"
                  value={format(new Date(voidInfo.VoidDate), 'MM/dd/yyyy')}
                />
                <Detail label="Voided By" value={voidInfo.VoidedBy} />
                <Detail label="Void Reason" value={voidInfo.VoidReason || voidInfo.Reason} />
              </div>
            )}
          </div>
        )
      case 'editbutton':
        if (!module || !appUserRights.includes(requiredEditRight)) return null
        return (
          <div key={ct.Id} style={{ marginTop: '10px' }}>
            <div>
              <ContextButton id={ct.Id} onClick={() => setEditModalOpen(true)} variant="secondary">
                {ct.Label}
              </ContextButton>
              <EditFilingModal
                editModalOpen={editModalOpen}
                setEditModalOpen={setEditModalOpen}
                label={ct.Label}
                filing={amendment}
                template={template}
                setHistory={setHistory}
                module={module}
              />
            </div>
          </div>
        )
      default:
        return <Detail label={ct.Label} value={value} key={ct.Id} />
    }
  }
  return (
    <div className="amendment-wrapper">
      <button
        className={`title ${expanded ? '' : 'collapsed'}`}
        role="button"
        onClick={toggleDrawer}
        aria-expanded={expanded}
      >
        {amendment.FilingType || amendment.AMENDMENT_TYPE}{' '}
        {duplicateAmendments.length > 0 && '(' + duplicateCounter + ')'}{' '}
        {(amendment.FilingDate || amendment.AMENDMENT_DATE) && (
          <span>- {amendment.FilingDate || amendment.AMENDMENT_DATE}</span>
        )}
        {expanded ? <CaretUpIcon /> : <CaretDownIcon />}
      </button>
      {expanded && (
        <div className="amendment-drawer" aria-live="polite">
          <div className={`amendment ${amendment.HISTORY.length === 0 ? 'no-history' : ''}`}>
            {(template || []).map((t) =>
              amendment[t.id || t.Id] !== null
                ? getDetailByType(t, amendment[t.id || t.Id], amendment)
                : t.id === 'voidInfo' || t.Id === 'voidInfo'
                  ? getDetailByType(t, amendment[t.id || t.Id], amendment)
                  : null,
            )}
          </div>
          {showChangedFromTo !== false && amendment.HISTORY.length > 0 && (
            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Field Name</th>
                    <th>Changed From</th>
                    <th>Changed To</th>
                  </tr>
                </thead>
                <tbody>
                  {(amendment.HISTORY || []).map((h) => (
                    <tr key={h.HISTORY_TYPE_ID || h.HistoryId}>
                      <td>{h.DISPLAY_NAME || h.DisplayName}</td>
                      <td>{h.CHANGED_FROM || h.ChangedFrom}</td>
                      <td>{h.CHANGED_TO || h.ChangedTo}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

const Detail = ({ label, value, children }) => (
  <div className="detail">
    <label>{label}</label>
    <span>{children || value}</span>
  </div>
)

export const CorrespondenceDownload = ({ template, value }) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const reportsInfo = useRequestData(
    (cb, errCb) => {
      if (value && !value.includes('/report//')) {
        setError(false)
        GET(
          value,
          (val) => {
            setLoading(false)
            cb(val)
          },
          (err) => {
            setLoading(false)
            setError(true)
            errCb(err)
          },
        )
      } else {
        setLoading(false)
        setError(false)
        // console.warn(value, 'Not a valid Report URL.')
        cb([])
      }
    },
    [value],
    [],
  )

  return (
    <Detail label={template.Label}>
      {loading ? (
        <div style={{ marginTop: '8px', marginLeft: '10px', marginBottom: '8px' }}>
          <Spinner themeColor="dark-neutral" size="small" />
        </div>
      ) : error ? (
        <p>Something went wrong while loading the documents. Try again later.</p>
      ) : (
        <div className="record-detail-reports-list">
          {(reportsInfo || []).map((report, i) => {
            return <Report key={i} report={report} delay={50 * i} />
          })}
          {reportsInfo.length === 0 ? <p>N/A</p> : null}
        </div>
      )}
    </Detail>
  )
}

const DownloaderWrapper = ({ href, filename, linkLabel = 'Download' }) => {
  const downloader = useRef()

  const handleDownload = () => {
    downloader.current.download()
  }

  return (
    <div>
      {href && (
        <button role="button" className="btn btn-raised btn-primary" onClick={handleDownload}>
          <div className="checkmark-wrapper left">
            <DownloadIcon />
          </div>
          {linkLabel}
        </button>
      )}
      <FileDownloader fileName={filename} href={href} ref={downloader} />
    </div>
  )
}
